/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as p from "react";
import d from "prop-types";
import { dispatchEvent as h, validatePackage as A, classNames as b, kendoThemeMaps as w, withIdHOC as F } from "@progress/kendo-react-common";
import { Button as S } from "@progress/kendo-react-buttons";
import { provideLocalizationService as O, registerForLocalization as P } from "@progress/kendo-react-intl";
import { caretDoubleAltRightIcon as x, caretDoubleAltLeftIcon as E, caretAltRightIcon as N, caretAltLeftIcon as y, caretAltUpIcon as R, caretAltDownIcon as K, xIcon as U } from "@progress/kendo-svg-icons";
var I = /* @__PURE__ */ ((n) => (n.TOP = "top", n.BOTTOM = "bottom", n.LEFT = "left", n.RIGHT = "right", n.NONE = "none", n))(I || {});
const z = {
  name: "@progress/kendo-react-listbox",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702645195,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
};
let k = class extends p.PureComponent {
  constructor(t) {
    super(t), this.setSelected = (e) => {
      if (this.props.selectedField)
        return !!e[this.props.selectedField];
    }, this.renderItem = (e) => this.props.textField ? e[this.props.textField] : e.toString(), this.handleKeyDown = (e) => {
      this.props.onKeyDown && h(this.props.onKeyDown, e, this, void 0);
    }, this.handleContainerDrop = (e) => {
      e.target.classList.contains("k-list-content") && (this.props.data.length > 0 ? h(this.props.onDrop, e, this, { dataItem: this.props.data[this.props.data.length - 1] }) : h(this.props.onDrop, e, this, { dataItem: null }));
    }, this.setToolbarPosition = () => this.props.toolbarPosition === I.NONE || this.props.toolbar === void 0 ? "" : `k-listbox-actions-${this.props.toolbarPosition}`, this.handleOnDragLeave = (e) => {
      this.props.onDragLeave && e.target.classList.contains("k-list-content") && h(this.props.onDragLeave, e, this, void 0);
    }, A(z);
  }
  get itemGuid() {
    return this.props.id + "-accessibility-id";
  }
  /**
   * @hidden
   */
  render() {
    return /* @__PURE__ */ p.createElement(
      "div",
      {
        id: this.props.id,
        className: b(
          this.props.className,
          "k-listbox",
          this.setToolbarPosition()
        ),
        style: this.props.style,
        unselectable: "on"
      },
      this.props.toolbar && this.props.toolbarPosition !== "bottom" && /* @__PURE__ */ p.createElement(this.props.toolbar, null),
      /* @__PURE__ */ p.createElement(
        "div",
        {
          className: "k-list-scroller k-selectable",
          "data-role": "selectable",
          onDragOver: (t) => t.preventDefault(),
          onDrop: this.handleContainerDrop,
          onDragLeave: this.handleOnDragLeave
        },
        /* @__PURE__ */ p.createElement("div", { className: b("k-list", {
          [`k-list-${w.sizeMap[this.props.size] || this.props.size}`]: this.props.size
        }) }, /* @__PURE__ */ p.createElement("div", { className: "k-list-content" }, /* @__PURE__ */ p.createElement("ul", { className: "k-list-ul", role: "listbox", "aria-label": "listbox-container", tabIndex: 0, onKeyDown: this.handleKeyDown }, this.props.data.map((t, e) => {
          const r = this.setSelected(t), s = {
            className: b(
              "k-list-item",
              {
                "k-selected": r
              }
            ),
            role: "option",
            "aria-selected": r,
            key: e,
            id: this.itemGuid + e,
            "data-uid": this.itemGuid + e,
            draggable: this.props.draggable,
            onDragStart: (o) => h(this.props.onDragStart, o, this, { dataItem: t }),
            onDragOver: (o) => {
              o.preventDefault(), h(this.props.onDragOver, o, this, { dataItem: t });
            },
            onDrop: (o) => h(this.props.onDrop, o, this, { dataItem: t }),
            onClick: (o) => h(this.props.onItemClick, o, this, { dataItem: t })
          };
          return this.props.item ? /* @__PURE__ */ p.createElement(this.props.item, { selected: r, dataItem: t, ...s, key: s.key }, /* @__PURE__ */ p.createElement("span", { className: "k-list-item-text" }, t.name)) : /* @__PURE__ */ p.createElement("li", { ...s, key: s.key }, /* @__PURE__ */ p.createElement("span", { className: "k-list-item-text" }, this.renderItem(t)));
        }))))
      ),
      this.props.toolbar && this.props.toolbarPosition === "bottom" && /* @__PURE__ */ p.createElement(this.props.toolbar, null),
      /* @__PURE__ */ p.createElement("select", { style: { display: "none" }, multiple: !0, "data-role": "listbox" }, this.props.data.map((t, e) => {
        const r = t[this.props.valueField || this.props.textField];
        return /* @__PURE__ */ p.createElement("option", { key: e, value: r }, r);
      }))
    );
  }
};
k.propTypes = {
  size: d.oneOf([null, "small", "medium", "large"]),
  toolbarPosition: d.oneOf(["none", "top", "bottom", "left", "right"]),
  textField: d.string,
  valueField: d.string,
  selectedField: d.string,
  data: d.array
};
k.defaultProps = {
  toolbarPosition: I.RIGHT,
  draggable: !0,
  size: "medium"
};
const M = "listbox.moveUp", G = "listbox.moveDown", $ = "listbox.transferTo", H = "listbox.transferFrom", V = "listbox.transferAllTo", j = "listbox.transferAllFrom", q = "listbox.remove", J = {
  [M]: "Move Up",
  [G]: "Move Down",
  [$]: "Transfer To",
  [H]: "Transfer From",
  [V]: "Transfer All To",
  [j]: "Transfer All From",
  [q]: "Delete"
}, L = [
  { name: "moveUp", iconName: "caret-alt-up", svgIcon: R },
  { name: "moveDown", iconName: "caret-alt-down", svgIcon: K },
  { name: "transferTo", iconName: "caret-alt-right", svgIcon: N },
  { name: "transferFrom", iconName: "caret-alt-left", svgIcon: y },
  { name: "transferAllTo", iconName: "caret-double-alt-right", svgIcon: x },
  { name: "transferAllFrom", iconName: "caret-double-alt-left", svgIcon: E },
  { name: "remove", iconName: "x", svgIcon: U }
];
class v extends p.PureComponent {
  constructor() {
    super(...arguments), this.checkSvgIcon = (t) => {
      switch (t.name) {
        case "caret-alt-right":
          return y;
        case "caret-alt-left":
          return N;
        case "caret-double-alt-right":
          return E;
        case "caret-double-alt-left":
          return x;
      }
      return t;
    }, this.checkFontIcon = (t) => {
      switch (t) {
        case "caret-alt-right":
          return "caret-alt-left";
        case "caret-alt-left":
          return "caret-alt-right";
        case "caret-double-alt-right":
          return "caret-double-alt-left";
        case "caret-double-alt-left":
          return "caret-double-alt-right";
      }
      return t;
    }, this.handleToolClick = (t, e) => {
      h(this.props.onToolClick, t, this, { toolName: e });
    }, this.isItemDisabled = (t) => {
      let e = !0;
      const r = this.props.selectedField || "selected", s = this.props.data.length, o = this.props.dataConnected.length, i = this.props.data.findIndex((a) => a[r] === !0) >= 0, l = this.props.dataConnected.findIndex((a) => a[r] === !0) >= 0;
      switch (t) {
        case "moveUp":
          i ? e = this.props.data.length > 0 ? this.props.data[0].selected : !0 : l ? e = this.props.dataConnected.length > 0 ? this.props.dataConnected[0].selected : !0 : e = !0;
          break;
        case "moveDown":
          i ? e = this.props.data[s - 1] ? this.props.data[s - 1].selected : !0 : l ? e = this.props.dataConnected.length > 0 ? this.props.dataConnected[o - 1].selected : !0 : e = !0;
          break;
        case "transferTo":
          e = !(this.props.dataConnected && i);
          break;
        case "transferFrom":
          this.props.dataConnected ? e = !(this.props.dataConnected && l) : e = !0;
          break;
        case "transferAllTo":
          e = !(this.props.dataConnected && this.props.data.length > 0);
          break;
        case "transferAllFrom":
          e = !(this.props.dataConnected && this.props.dataConnected.length > 0);
          break;
        case "remove":
          e = !(i || l);
          break;
      }
      return e;
    };
  }
  get isRtl() {
    return this.props.dir === "rtl";
  }
  /**
   * @hidden
   */
  render() {
    const t = O(this);
    return /* @__PURE__ */ p.createElement(
      "div",
      {
        className: b(
          "k-listbox-actions"
        )
      },
      this.props.tools && this.props.tools.map((e, r) => {
        const s = L.findIndex((c) => c.name === e), o = L[s], i = this.isItemDisabled(o.name), l = `listbox.${o.name}`, a = t.toLanguageString(l, J[l]);
        return /* @__PURE__ */ p.createElement(
          S,
          {
            key: r,
            disabled: i,
            "data-command": o.name,
            title: a,
            "aria-label": a,
            icon: this.isRtl ? this.checkFontIcon(o.iconName) : o.iconName,
            svgIcon: this.isRtl ? this.checkSvgIcon(o.svgIcon) : o.svgIcon,
            onClick: (c) => {
              c.preventDefault(), this.handleToolClick(c, o.name || null);
            }
          }
        );
      })
    );
  }
}
v.propTypes = {
  data: d.array,
  dataConnected: d.array,
  tools: d.array,
  selectedField: d.string,
  dir: d.string
};
v.defaultProps = {
  data: [],
  dataConnected: [],
  selectedField: "selected"
};
P(v);
const tt = (n = [], t = [], e, r) => {
  let s = [], o = [], i = [];
  const l = {
    listBoxOneData: n,
    listBoxTwoData: t
  };
  switch (e) {
    case "moveUp":
      s = [...n], s.forEach((a, c) => {
        a[r] && (s = u(c, c - 1, s));
      }), i = [...t], i.forEach((a, c) => {
        a[r] && (i = u(c, c - 1, i));
      }), l.listBoxOneData = s, l.listBoxTwoData = i;
      break;
    case "moveDown":
      s = n.reverse(), s.forEach((a, c) => {
        a[r] && (s = u(c, c - 1, s));
      }), i = t.reverse(), i.forEach((a, c) => {
        a[r] && (i = u(c, c - 1, i));
      }), l.listBoxOneData = [...s].reverse(), l.listBoxTwoData = [...i].reverse();
      break;
    case "transferTo":
      s = n.filter((a) => !a[r]), o = n.filter((a) => a[r]), i = t.concat(o), l.listBoxOneData = s, l.listBoxTwoData = i;
      break;
    case "transferFrom":
      i = t.filter((a) => !a[r]), o = t.filter((a) => a[r]), s = n.concat(o), l.listBoxOneData = s, l.listBoxTwoData = i;
      break;
    case "transferAllTo":
      l.listBoxOneData = [], l.listBoxTwoData = t.concat(n);
      break;
    case "transferAllFrom":
      l.listBoxOneData = t.concat(n), l.listBoxTwoData = [];
      break;
    case "remove":
      i = t.filter((a) => !a[r]), s = n.filter((a) => !a[r]), l.listBoxOneData = s, l.listBoxTwoData = i;
      break;
  }
  return l;
}, u = (n, t, e) => {
  const r = e.splice(n, 1)[0];
  return e.splice(t, 0, r), e;
}, et = (n = [], t = [], e, r, s) => {
  const o = n.findIndex((m) => m[s] === e[s]), i = t.findIndex((m) => m[s] === e[s]), l = r !== null ? n.findIndex((m) => m[s] === r[s]) : -1, a = r !== null ? t.findIndex((m) => m[s] === r[s]) : -1, c = o >= 0, D = i >= 0, T = l >= 0, C = a >= 0, f = [...n], g = [...t];
  return c && T ? {
    listBoxOneData: u(o, l, n),
    listBoxTwoData: t
  } : D && C ? {
    listBoxOneData: n,
    listBoxTwoData: u(i, a, t)
  } : c && (C || r === null) ? (r === null ? g.push(n[o]) : g.splice(a + 1, 0, n[o]), f.splice(o, 1), {
    listBoxOneData: f,
    listBoxTwoData: g
  }) : D && (T || r === null) ? (r === null ? f.push(t[i]) : f.splice(l + 1, 0, t[i]), g.splice(i, 1), {
    listBoxOneData: f,
    listBoxTwoData: g
  }) : {
    listBoxOneData: n,
    listBoxTwoData: t
  };
}, Q = F(k);
Q.displayName = "KendoReactListBox";
export {
  Q as ListBox,
  v as ListBoxToolbar,
  u as moveItem,
  tt as processListBoxData,
  et as processListBoxDragAndDrop
};
